import { Camera } from 'react-bytesize-icons';
import video1 from "../../../../assets/videos/recording/video1.mp4";
import video2 from "../../../../assets/videos/recording/video2.mp4";
import * as React from 'react';
export default {
  Camera,
  video1,
  video2,
  React
};